'use strict';
import 'project-light/stylesheets/full-stylesheet.css';
import { bootstrap as bootstrapProjectLight } from 'project-light/javascripts/custom';

const $ = require('jquery');
const env = process.env.NODE_ENV;  // webpack compile-time constant

function isLoaded(styleLink) {
    return [].slice.apply(window.document.styleSheets)
        .some((sh) => sh.href === styleLink.href);
}

if (env === 'production') {
    $.migrateMute = true;  // Logs "logging active" before this takes effect
    $(bootstrapProjectLight);
} else {
    $(() => {
        // Start project light in the next tick to give CSS loaded in Blobs time to
        // apply. The PL CSS must be applied before PL runs, as it shows stuff
        // using $.show() which does nothing if the PL CSS has not made the target
        // invisible.

        let startTime = Date.now();

        let loadedLinks = $('head link[rel=stylesheet][href^="blob:"]')
            .toArray()
            .map(link => new Promise((resolve, reject) => {
                if(isLoaded(link)) {
                    resolve(link);
                }
                else {
                    $(link).on('load', () => resolve(link))
                        .on('error', () => reject(link));
                }
            }));

        Promise.all(loadedLinks)
            .then(() => {
                let millis = Date.now() - startTime;
                console.info('All stylesheets loaded, starting projectlight ' +
                    ` (${millis}ms delay)`);
                bootstrapProjectLight();
            })
            .catch(link => {
                console.error('Unable to load projectlight: ' +
                    `stylesheet failed to load: ${link.href}`);
            });
    });
}
